import { Star, PenLine, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

export const GOOGLE_READ_URL =
  "https://www.google.com/maps/search/?api=1&query=Kay%27s%20Carpet%20Cleaning&query_place_id=ChIJQRCCNsT4NSoR2NLBUc0Umoo";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CdjSwVHNFJqKECE/review";

export const GoogleReviews = () => (
  <section data-testid="google-reviews-section" className="py-24 sm:py-32">
    <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <Overline>Google Reviews</Overline>
        <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl leading-[1.08] tracking-tight text-brand-ink">
          See What Our <span className="font-serif italic text-brand">Customers Say</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-brand-muted leading-relaxed max-w-2xl mx-auto">
          See genuine customer feedback about Kay's Carpet Cleaning on Google, or share
          your own experience after using our service.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <a
            href={GOOGLE_READ_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="read-google-reviews-button"
            aria-label="Read our Google Reviews (opens in a new tab)"
            className="group inline-flex items-center justify-center gap-2.5 bg-brand hover:bg-brand-dark text-white font-semibold px-7 py-4 rounded-full text-base shadow-[0_10px_30px_rgba(11,114,133,0.28)] transition-[background-color,transform] duration-300 hover:scale-[0.97]"
          >
            <Star size={18} />
            Read Our Google Reviews
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="leave-google-review-button"
            aria-label="Leave a Google Review (opens in a new tab)"
            className="group inline-flex items-center justify-center gap-2.5 bg-white border border-brand-line text-brand-ink font-semibold px-7 py-4 rounded-full text-base transition-[border-color,transform] duration-300 hover:border-brand hover:scale-[0.97]"
          >
            <PenLine size={18} className="text-brand" />
            Leave a Google Review
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
